import { render } from "./RequisitesGroupEditPopup.vue?vue&type=template&id=55378eb4&ts=true"
import script from "./RequisitesGroupEditPopup.vue?vue&type=script&lang=ts"
export * from "./RequisitesGroupEditPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__